export default {
    loading: false,
    error: null,
    model: {},
    contracts: null,
    token: null,
    refreshError: null,
};
